/* eslint-disable eqeqeq */
import { memo } from 'react';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useSearch from 'hooks/useSearch';
import { useLocation } from 'react-router-dom';
import Shaxmatka from './shaxmatka';
import ShowroomHomeDetail from './home-modals/ShowroomHomeDetail';
import ShaxmatkaPlus from './shaxmatkaPlus';
import ShaxmatkaVisualView from './visual-view';

export default memo(function ShowroomPanel({ tabValue }) {
  const { search } = useLocation();
  const query = useSearch();
  const axiosPrivate = useAxiosPrivate();

  const homesApi = useQuery({
    queryKey: ['/admin/home/padezd/', search],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/admin/home/padezd/${query?.get('objectId')}${search}`
      );
      return response.data.data;
    },
    enabled: !!query?.get('objectId'),
    retry: false,
  });

  return (
    <div className='flex w-full h-full min-h-[400px] gap-4'>
      <div
        className={
          'base-border grow bg-white h-full p-5 w-[calc(100%-320px)] basis-[calc(100%-320px)]'
        }
      >
        <div className='w-full h-full'>
          {tabValue == 1 && (
            <Shaxmatka
              homes={homesApi?.data}
              isLoading={homesApi?.isLoading || homesApi?.isFetching}
            />
          )}
          {tabValue == 2 && (
            <ShaxmatkaPlus
              homes={homesApi?.data}
              isLoading={homesApi?.isLoading || homesApi?.isFetching}
            />
          )}
          {tabValue == 3 && <ShaxmatkaVisualView />}
        </div>
      </div>
      <ShowroomHomeDetail />
    </div>
  );
});
